





























































import Vue from 'vue'
import {MSGR_VK, MSGR_TG, MSGR_VB, MSGR_TT, MSGR_MAX, MSGR_LDP, MSGR_DC} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';
export const MSGRS: {[key: string]: {icon: string, color: string, label: string}} = {
  [MSGR_MAX]: {
    icon: 'static/img/icons/msgrs/max.png',
    color: '',
    label: 'MAX'
  },
  [MSGR_VK]: {
    icon: 'static/img/icons/msgrs/vk_new_white.svg',
    color: '#0077FF',
    label: messages.common.socials.vk
  },
  [MSGR_TG]: {
    icon: 'static/img/icons/msgrs/tg_white.svg',
    color: '#279DD4',
    label: messages.common.socials.tg
  },
  [MSGR_VB]: {
    icon: 'static/img/icons/msgrs/vb_white.svg',
    color: '#8527B4',
    label: messages.common.socials.vb
  },
  [MSGR_TT]: {
    icon: 'static/img/icons/msgrs/tt_white.svg',
    color: '#697CFF',
    label: messages.common.socials.tt
  },
  [MSGR_LDP]: {
    icon: 'static/img/icons/msgrs/ldp_white.svg',
    color: 'linear-gradient(55.38deg, #F8822D 25.06%, #F8BF2D 65.22%)',
    label: 'Lionsdigital'
  },
  [MSGR_DC]: {
    icon: 'static/img/icons/msgrs/discord_white.svg',
    color: '#5865F2',
    label: messages.common.socials.dc
  }
}
export default Vue.extend({
  props: {
    type: String,
    ok: Boolean,
    err: Boolean,
    size: {
      type: Number,
      default: 18
    },
    showLabel: Boolean
  },
  methods: {
    getType (): string {
      switch (this.type) {
        case MSGR_MAX:
          return MSGR_MAX;
          break;
        case MSGR_VK:
          return MSGR_VK;
          break;
        case MSGR_TG:
          return MSGR_TG;
          break;
        case MSGR_VB:
          return MSGR_VB;
        case MSGR_TT:
          return MSGR_TT;
          break;
        case MSGR_LDP:
          return MSGR_LDP;
          break;
        case MSGR_DC:
          return MSGR_DC;
          break;
        default:
          console.error('Unknow messenger type! ', this.type)
          return ''
          break;
      }
    },
    getPath (): string {
      return MSGRS[this.getType()].icon;
    },
    getColor (): string | undefined {
      return MSGRS[this.getType()].color || undefined;
    },
    getLabel (): string {
      return MSGRS[this.getType()].label;
    },
  }
})
